const ITEMS = [
  "Tool reali per problemi veri",
  "100% in italiano",
  "Video virali in 60 secondi",
  "getmimis.com",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center">
        <span
          className={`font-display whitespace-nowrap px-6 text-4xl font-bold tracking-tight sm:text-6xl lg:text-7xl ${
            i % 2 ? "text-outline" : "text-[#111111]"
          }`}
        >
          {t}
        </span>
        <img src="/logo-mimis.png" alt="" className="h-8 w-auto sm:h-11" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-[#e7e7ea] bg-white py-8 sm:py-12" data-testid="marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
